import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { environment } from '../environments/environment';
import { BlankComponent } from './layouts/blank/blank.component';
import { AuthGuard } from './authentication/guard/auth.guard';

let appuri,
  logouturi,
  report_serveruri,
  leadupload,
  voiceupload,
  dncupload,
  // profileUpload,
  // fileupload,
  didupload,
  gallerydir,
  stripekey,
  tiffdir,
  leadupload1,
  pngdir,
  messageupload1,
  // audiouploadpath,
  messageupload,
  didFileUpload,
  detaildidFileUpload,
  downloaddir,
  // appurl,
  // ciapiuri,
  audioupload,
  audiopath,
  ivraudio,
  audiowithlang,
  sipuri: string

if (environment.production) {
  appuri = environment.SERVER;
  logouturi = environment.SERVER + 'logout';
  report_serveruri = environment.report_server;
  leadupload1 = environment.SERVER + 'uploadedbycamp';
  leadupload = environment.SERVER + 'uploads';
  voiceupload = environment.SERVER + 'uploads';
  // profileUpload = environment.SERVER + 'uploads';
  dncupload = environment.SERVER + 'dnc';
  // fileupload = environment.SERVER + 'fileupload';
  // appurl = environment.SERVERURL;
  messageupload = environment.SERVER + 'message';
  messageupload1 = environment.SERVER + 'messagebycamp';
  // audiouploadpath=environment.SERVER+ 'audiobycamp'
  // ciapiuri = environment.CISERVER;
  gallerydir = "assets/voicemail/";
  didFileUpload = environment.SERVER + 'uploads/didupload';
  detaildidFileUpload = environment.SERVER + 'uploads/Detaildidupload';
  // stripekey = environment.STRIPEKEY;
  audiopath = "assets/audio/";
  // sipuri = environment.sipURI,
  audioupload = environment.SERVER + 'messagebycamp';
  audiowithlang = environment.SERVER + 'audiolanguage';
  ivraudio = environment.SERVER + 'audioIVR';
}
else {
  appuri = environment.SERVER;
  logouturi = environment.SERVER + 'logout';
  leadupload = environment.SERVER + 'uploads';
  voiceupload = environment.SERVER + 'uploads';
  report_serveruri = environment.report_server;
  leadupload1 = environment.SERVER + 'uploadedbycamp';
  // profileUpload = environment.SERVER + 'uploads';
  didupload = environment.SERVER + 'uploads/didupload/';
  dncupload = environment.SERVER + 'dnc';
  messageupload = environment.SERVER + 'message';
  messageupload1 = environment.SERVER + 'messagebycamp';
  // audiouploadpath=environment.SERVER+ 'audiobycamp'
  // fileupload = environment.SERVER + 'fileupload';
  // appurl = environment.SERVERURL;
  // ciapiuri = environment.CISERVER;
  gallerydir = "assets/voicemail/";
  // stripekey = environment.STRIPEKEY;
  didFileUpload = environment.SERVER + 'uploads/didupload';
  detaildidFileUpload = environment.SERVER + 'uploads/Detaildidupload';
  audiopath = "assets/audio/"
  // sipuri = environment.sipURI
  audioupload = environment.SERVER + 'messagebycamp'
  audiowithlang = environment.SERVER + 'audiolanguage';
  ivraudio = environment.SERVER + 'audioIVR'
  

}

// export const DownloadPath = "http://" + environment.SERVERURL + "/download/";
// export const CIAPIURL = ciapiuri;
export const APIURL = appuri;
export const LogoutURL = logouturi;
export const ReportServerURL = report_serveruri;
export const LeadsUpload = leadupload;
export const Didupload = didupload;
export const VoiceUpload = voiceupload;
// export const ProfileUpload = profileUpload;
export const MessageUpload = messageupload;
export const LeadsUpload1 = leadupload1;
export const MessageUpload1 = messageupload1;
// export const AudioUploadPath=audiouploadpath
export const DncUpload = dncupload;
// export const FileUpload = fileupload;
// export const AUDIOURL = appurl;
export const STRIPE_KEY = stripekey;
export const DidFileUpload = didFileUpload;
export const DidFileUpload1 = detaildidFileUpload;
export const GalleryPath = gallerydir;
//export const TiffPath= tiffdir;
//export const PngPath= pngdir;
//export const DownloadPath= downloaddir;
export const AudioPath = audiopath
export const AudioUpload = audioupload
export const AudioLang = audiowithlang
export const SIPURI = sipuri
export const IVR_audio = ivraudio;
export const uploadImage = environment.SERVER + "uploadImage"
export const fileMove = environment.SERVER + "fileMove"

export const AppRoutes: Routes = [

  {
    path: '',
    component: BlankComponent,
    children: [{
      path: '',
      redirectTo: 'login',
      pathMatch: 'full'
    }, {
      path: 'login',
      loadChildren: './authentication/authentication.module#AuthenticationModule'
    }]
  }, {
    path: '**',
    redirectTo: 'authentication/404'
  }, {
    path: 'main',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboards',
        pathMatch: 'full',
      },
      {
        path: 'dashboards',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },

      {
        path: 'automation',
        loadChildren: './automation/automation.module#AutomationModule'
      },

      {
        path: 'profile',
        loadChildren: './profile/profile.module#ProfileModule'
      },
      {
        path: 'billing',
        loadChildren: './billing/billing.module#BillingModule'
      },
      // {
      //   path: 'agent',
      //   loadChildren: './agent/agent.module#AgentModule'
      // },
      {
        path: 'agent',
        loadChildren: './agents/agents.module#AgentsModule'
      },
      //   {
      //     path: 'apps/user',
      //     loadChildren: './apps/user/user.module#UserModule'
      //   },
      //   {
      //     path: 'apps/agent',
      //     loadChildren: './apps/agent/agent.module#AgentModule'
      //   },
      {
        path: 'campaigns',
        loadChildren: './campaigns/campaigns.module#CampaignsModule'
      },
      {
        path: 'smsbroad',
        loadChildren: './smsbroad/smsbroad.module#SmsbroadModule'
      },


      {
        path: 'contact',
        loadChildren: './grouplist/grouplist.module#GrouplistModule'
      },
      {
        path: 'ivrboard',
        loadChildren: './ivrboard/ivrboard.module#IvrboardModule'
      },
      //   {
      //     path: 'apps/profile',
      //     loadChildren: './apps/profile/profile.module#ProfileModule'
      //   },
      //   {
      //     path: 'apps/lead',
      //     loadChildren: './apps/lead/lead.module#LeadModule'
      //   },
      //   {
      //     path: 'apps/paypal',
      //     loadChildren: './apps/paypal/paypal.module#PaypalModule'
      //   },
      //   {
      //     path: 'apps/usage',
      //     loadChildren: './apps/usage/usage.module#UsageModule'
      //   },
      {
        path: 'message',
        loadChildren: './message/message.module#MessageModule'
      },
      {
        path: 'listdid',
        loadChildren: './dids/dids.module#DidsModule'
      },
      {
        path: 'calendar',
        loadChildren: './calendar/calendar.module#Calendar1Module'
      },
      {
        path: 'email-setting',
        loadChildren: './email/email.module#EmailModule'
      },
      {
        path: 'support',
        loadChildren: './support/support.module#SupportModule'
      },
      // {
      //   path: 'chat',
      //   loadChildren: './chat/chat.module#ChatModule'
      // },
      //   {
      //     path: 'apps/dnc',
      //     loadChildren: './apps/dnc/dnc.module#DncModule'
      //   },
      //   {
      //     path: 'apps/blocked',
      //     loadChildren: './apps/blocked/blocked.module#BlockedModule'
      //   },
      //   {
      //     path: 'apps/grouplist',
      //     loadChildren: './apps/grouplist/grouplist.module#GrouplistModule'
      //   },
      //   {
      //     path: 'apps/carriers',
      //     loadChildren: './apps/carriers/supplier.module#SupplierModule'
      //   },
      //   {
      //     path: 'apps/package',
      //     loadChildren: './apps/package/package.module#PackageModule'
      //   },
      // {
      //   path: 'apps/report',
      //   loadChildren: './report/report.module#ReportModule'
      // },
      {
        path: 'report',
        loadChildren: './reports/reports.module#ReportsModule'
      },
      {
        path: 'calendar',
        loadChildren: './calendar/calendar.module#Calendar1Module'
      },




      //   {
      //     path: 'apps/script',
      //     loadChildren: './apps/script/script.module#ScriptModule'
      //   },
      // {
      //   path: 'smstemplate',
      //   loadChildren: './smstemplate/smstemplate.module#SmstemplateModule'
      // },
      // {
      //   path: 'emailtemplate',
      //   loadChildren: './emailtemplate/emailtemplate.module#EmailtemplateModule'
      // },

      {
        path: 'setting',
        loadChildren: './setting/setting.module#SettingModule'
      },
      {
        path: 'support',
        loadChildren: './support/support.module#SupportModule'
      },

      {
        path: 'lead',
        loadChildren: './leads/leads.module#LeadsModule'
      },
      // admin

      {
        path: 'admin/adminsetting',
        loadChildren: './admin/adminsetting/adminsetting.module#AdminsettingModule'
      },

      {
        path: 'admin/packages',
        loadChildren: './admin/packages/packages.module#PackagesModule'
      },
      {
        path: 'admin/keyword',
        loadChildren: './admin/keyword/keyword.module#KeywordModule'
      },

      {
        path: 'admin/usermanager',
        loadChildren: './admin/usermanager/usermanager.module#UsermanagerModule'
      },
      {
        path: 'admin/supplier',
        loadChildren: './admin/supplier/supplier.module#SupplierModule'
      },
      {
        path: 'admin/server',
        loadChildren: './admin/server/server.module#ServerModule'
      },
      {
        path: 'avatar',
        loadChildren: './avatur/avatur.module#AvaturModule'
      },
      {
        path: 'dialer-reports',
        loadChildren: './modules/dialer-reports/dialer-reports.module#DialerReportsModule'
      }


    ]
  }
];